import { render, staticRenderFns } from "./sensor.vue?vue&type=template&id=fbbe9f6c"
import script from "./sensor.vue?vue&type=script&lang=js"
export * from "./sensor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports